import React from "react";
import { Text, View } from "react-native";
import { TouchableOpacity } from "react-native-gesture-handler";
import t from "@constants/localization";
import metrics from "../../../constants/metrics";
import { getData, setData } from "../../../lib/storage";
import { submitPoll } from "../../../services/api";
import ScalableText from "./ScalableText";

const PATH = "screens/Story";

const BinaryPoll = (props) => {
  const {
    id = "",
    header = "",
    header_color = "white",
    answers = [
      {
        answer: "",
        answer_color: "green",
      },
      {
        answer: "",
        answer_color: "green",
      },
    ],

    pauseStory = () => {},
    unpauseStory = () => {},
    submitted,
    setSubmitted,
    trackEvent = () => {},
  } = props;

  const onSubmit = (answerId) => () => {
    trackEvent({ pollId: id, answerId });
    submitPoll({ pollId: id, answerId })
      .then(async () => {
        setSubmitted((s) => [...s, id]);
        const submittedPolls = (await getData("cmsSubmittedPolls")) ?? [];
        await setData("cmsSubmittedPolls", [...submittedPolls, id]);
      })
      .catch((err) => console.log(err));
  };

  return (
    <View
      style={{
        flex: 1,
        alignSelf: "center",
        position: "absolute",
        zIndex: 10,
        width: metrics.screenWidth - 60,
        left: 30,
      }}
    >
      <Text
        style={{
          fontFamily: "NotoSansDevanagari-Bold",
          color: header_color ?? "white",
          fontSize: 24,
          textAlign: "center",
          marginBottom: 20,
        }}
      >
        {header}
      </Text>
      {submitted ? (
        <View
          style={{
            backgroundColor: "white",
            padding: 20,
            borderRadius: 10,
            marginBottom: 6,
          }}
        >
          <Text style={{ textAlign: "center", fontSize: 20, opacity: 0.56 }}>
            {t(`${PATH}/youHaveAnswered`)}
          </Text>
        </View>
      ) : (
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "stretch",
            overflow: "hidden",
            borderRadius: 10,
            backgroundColor: "white",
          }}
        >
          {Array.isArray(answers) &&
            answers.map(({ answer, answer_color, id: answerId }, index) => (
              <React.Fragment key={answerId}>
                <View
                  style={{
                    flex: 1,
                  }}
                >
                  <TouchableOpacity
                    disabled={submitted}
                    onPressIn={pauseStory}
                    onPressOut={unpauseStory}
                    onPress={onSubmit(answerId)}
                    style={{
                      flex: 1,
                      paddingVertical: 20,
                      justifyContent: "center",
                      alignItems: "stretch",
                    }}
                  >
                    <ScalableText
                      minSize={11}
                      fontSize={26}
                      numberOfLines={2}
                      style={{
                        color: answer_color ?? "black",
                        textTransform: "uppercase",
                        textAlign: "center",
                        width: "100%",
                        paddingHorizontal: 4,
                        fontFamily: "Muli-SemiBold",
                      }}
                    >
                      {answer}
                    </ScalableText>
                  </TouchableOpacity>
                </View>
                {index !== answers.length - 1 && (
                  <View
                    style={{
                      height: "100%",
                      width: 1,
                      backgroundColor: "rgba(0,0,0,0.2)",
                    }}
                  />
                )}
              </React.Fragment>
            ))}
        </View>
      )}
    </View>
  );
};

export default BinaryPoll;
